import { NgModule } from '@angular/core';
import { DeployUrlPipe } from './deploy-url.pipe';

@NgModule({
  declarations: [DeployUrlPipe],
  exports: [DeployUrlPipe],
})
export class DeployUrlModule {}
